import axiosInstance from '@/utils/api.js'

function validation (payload) {
  payload.is_enabled = parseInt(payload.is_enabled, 10)
  payload.group_id = parseInt(payload.group_id, 10)
}

var state = {
  activating_card_settings: []
}

var getters = {
  ACTIVATING_CARD_SETTINGS: (state) => {
    return state.activating_card_settings
  }
}

var mutations = {
  SET_ACTIVATING_CARD: (state, payload) => {
    state.activating_card_settings = payload
  }
}

var actions = {
  GET_ACTIVATING_CARD: async (context, payload) => {
    let result = await axiosInstance.get('/settings/available_activating_card')
    if (result.status === 200) {
      context.commit('SET_ACTIVATING_CARD', result.data)
    }
  },
  CREATE_ACTIVATING_CARD: (context, payload) => {
    validation(payload)
    return axiosInstance.post('/settings/available_activating_card', payload)
  },
  UPDATE_ACTIVATING_CARD: (context, payload) => {
    validation(payload)
    return axiosInstance.put('/settings/available_activating_card', payload)
  },
  DELETE_ACTIVATING_CARD: (context, payload) => {
    return axiosInstance.delete('/settings/available_activating_card?id=' + payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/settings/activating_card.js